export const MANAGEMENT_TEAM = "management";
export const SYSTEM_ADMIN_TEAM = "system admin";
export const SYSTEM = "system";